import Header from './components/Header/Header' ;
import List from './components/List/List' ;
import Map from './components/Map/Map' ;
import {CssBaseline , Grid } from '@material-ui/core';
import { useEffect, useState } from 'react';
import {getPlacesData,getWeatherData} from './api/index'


function App() {

  const [places, setPlaces] = useState([])            //store places data coming from the api
  const [coordinates, setCoordinates] = useState({})      //store the updating coordinates 
  const [coords, setCoords] = useState({})      //store for default coordinates at the begining used by google map component
  const [boundaries, setBoundaries] = useState({})      //store map boundaries(north east , south west) to pass it later to the function that fetch the api
 
  const [childClicked, setChildClicked] = useState(null)   //store clicked (place on the map) & pass it as prop (defining it here to pass it to more than one component instead of using redux [uplifting state])
  const [isLoading, setIsLoading] = useState(false)     //store value if the app is loading to fetch data (to show load icon)
  
  const [type,setType]= useState('restaurants') ;     //store the select menu value of the hotels & .... (set here to be used in multi components instead of using redux)
  const [rating,setRating]= useState(0) ;             //store the select menu value of the ratings    (set here to be used in multi components instead of using redux)
  const [filteredPlaces, setFilteredPlaces] = useState([]);  //store filtered places after choose rating from the menu 

  const [weatherData, setWeatherData] = useState([]);     //store weather data 

  //get user current location from the browser when the web app start
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(({coords:{latitude,longitude}})=>{
      setCoordinates({lat :latitude, lng :longitude }) ;
      setCoords({lat :latitude, lng :longitude }) ;
    }) 
  }, []) ;

  //filter places by rating menu
   useEffect(() => {    
    setFilteredPlaces(places?.filter((place) => Number(place.rating) > rating));
  }, [rating,places]) ;   

  //call the funcition of the component that fetch the APIs and pass place type & boundaries data to getplaces then get the fetched data and store it in places state
  useEffect(() => {
    if (boundaries.sw && boundaries.ne){
     setIsLoading(true) ;
     getWeatherData(coordinates.lat,coordinates.lng).then((data) => setWeatherData(data)); //call the funcition that fetch the weather & pass coordinates to it then get the fetched data and store it in weather state
     getPlacesData(type,boundaries.ne,boundaries.sw).then((data)=>{
     setPlaces(data?.filter((place) => place.name && place.num_reviews > 0));  //store the fetched places but first filter them to remove dummy places that has no name or reviews
     setFilteredPlaces([]);         //clear the rating filtered select menu state
     setIsLoading(false) } ) }
    }  , [type,boundaries]) ;

    //show the header then show our components ( list & map ) as Matrial ui Grid items & pass props to them
  return (
    <div className="App">
      <CssBaseline />
      <Header setCoordinates={setCoordinates}/>
      <Grid container spacing={3} style={{width:'100%'}} >
          <Grid item xs={12} md={4}> 
          <List places={filteredPlaces?.length ? filteredPlaces : places} childClicked={childClicked} isLoading={isLoading} type={type} setType={setType} rating={rating} setRating={setRating} />
          </Grid>
          <Grid item xs={12} md={8}>
          <Map places={filteredPlaces?.length ? filteredPlaces : places} coordinates={coordinates} coords={coords} setCoordinates={setCoordinates} setBoundaries={setBoundaries} setChildClicked={setChildClicked} weatherData={weatherData}/>  
          </Grid>
      </Grid> 
    </div>
  );
}

export default App;
